$(document).ready(function () {
    var accordions = document.querySelectorAll('div.accordion .collapse');
    accordions.forEach((accordion) => {
        accordion.addEventListener('show.bs.collapse', function () {
            var parentButton = accordion.parentElement.querySelector('button i.fa-light');
            parentButton.classList.remove('fa-plus');
            parentButton.classList.add('fa-minus');
        });
        accordion.addEventListener('hide.bs.collapse', function () {
            var parentButton = accordion.parentElement.querySelector('button i.fa-light');
            parentButton.classList.add('fa-plus');
            parentButton.classList.remove('fa-minus');
        });
    });
});
